import { useDispatch as useDispatchOrg, useSelector as useSelectorOrg } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { referral } from "./slices/referral";
export const rootReducer = combineReducers({
    referral: referral.reducer,
});
export const store = configureStore({
    reducer: rootReducer,
    devTools: process.env.NODE_ENV !== "production",
    preloadedState: {},
});
export const useDispatch = useDispatchOrg;
export const useSelector = useSelectorOrg;
